module.exports = __webpack_public_path__ + "static/media/search_dropdown.51946304.svg";